var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 5.64638 2.14048 5.30724 2.39052 5.05719C2.64057 4.80714 2.97971 4.66666 3.33333 4.66666H3.95333C4.17279 4.6667 4.38886 4.61256 4.58238 4.50906C4.77589 4.40555 4.94087 4.25589 5.06267 4.07333L5.604 3.26C5.7258 3.07744 5.89077 2.92777 6.08429 2.82427C6.27781 2.72077 6.49388 2.66663 6.71333 2.66666H9.28667C9.50612 2.66663 9.7222 2.72077 9.91571 2.82427C10.1092 2.92777 10.2742 3.07744 10.396 3.26L10.9373 4.07333C11.0591 4.25589 11.2241 4.40555 11.4176 4.50906C11.6111 4.61256 11.8272 4.6667 12.0467 4.66666H12.6667C13.0203 4.66666 13.3594 4.80714 13.6095 5.05719C13.8595 5.30724 14 5.64638 14 6V12C14 12.3536 13.8595 12.6928 13.6095 12.9428C13.3594 13.1929 13.0203 13.3333 12.6667 13.3333H3.33333C2.97971 13.3333 2.64057 13.1929 2.39052 12.9428C2.14048 12.6928 2 12.3536 2 12V6Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.66666C10 9.1971 9.78929 9.70581 9.41421 10.0809C9.03914 10.456 8.53043 10.6667 8 10.6667C7.46957 10.6667 6.96086 10.456 6.58579 10.0809C6.21071 9.70581 6 9.1971 6 8.66666C6 8.13623 6.21071 7.62752 6.58579 7.25245C6.96086 6.87738 7.46957 6.66666 8 6.66666C8.53043 6.66666 9.03914 6.87738 9.41421 7.25245C9.78929 7.62752 10 8.13623 10 8.66666Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOutline);
export default __webpack_public_path__ + "static/media/CameraOutline.94a8217a9d64069d521a0427afbcf02f.svg";
export { ForwardRef as ReactComponent };